import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { Form, FormGroup, Label, Row, Col, Alert } from "reactstrap";
import { post } from "axios";

import { API_BASE_URL } from "../../../../_services/constant";
import { postMethod } from "../../../../_services/_postMethod";
import Loader from "../../../modules/loader";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AddCategory = (props) => {
  const queryParams = useQuery();
  const id = queryParams.get("id") === "" ? null : queryParams.get("id");
  const { register, handleSubmit } = useForm();
  const [load, setLoad] = useState(false);
  const [loadInser, setLoadInsert] = useState(false);
  const [loadDelete, setLoadDelete] = useState(false);
  const [loadDeleteMsg, setLoadDeleteMsg] = useState("Deleted");
  const [imageValidation1, setImageValidation1] = useState(false);
  const [imageValidation2, setImageValidation2] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [formInsertData, setFormInsertData] = useState({
    category_id: "0",
    category_name: "",
    image_path: "",
    banner_path: "",
  });
  const [imageObj, setImageObj] = useState({
    image: "",
    banner: "",
  });
  const [categoryNameError, setCategoryNameError] = useState("");
  const [success, setSuccess] = useState(false);
  const [successDelete, setSuccessDelete] = useState(false);

  function createGuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  const getImageSrc = (value, basePath) => {
    if (!value) {
      return "";
    }

    return value.indexOf("data:") === 0 ? value : API_BASE_URL + basePath + value;
  };

  const previewFile = (file, key) => {
    if (!file) {
      return;
    }

    const reader = new FileReader();
    reader.onload = function (event) {
      setImageObj((prev) => ({ ...prev, [key]: event.target.result }));
    };
    reader.readAsDataURL(file);
  };

  const getNormalizedImagePath = (file, prefix) => {
    const fileName = prefix + createGuid();
    let extension = file.name.substring(file.name.lastIndexOf("."));

    if (extension.toLowerCase() === ".jpeg") {
      extension = ".jpg";
    }

    return fileName + extension;
  };

  const isDuplicateCategoryName = (name) => {

  // Edit mode mein duplicate check mat karo
  if (id !== null) {
    return false;
  }

  const normalizedName = (name || "").trim().toLowerCase();

  if (!normalizedName) return false;

  return categoryList.some((item) => {
    return (
      (item.category_name || "").trim().toLowerCase() === normalizedName
    );
  });
};
  const insertData = (values) => {
      if (id === null && isDuplicateCategoryName(formInsertData.category_name)) {
    setCategoryNameError("This category name already exists");
    return;
  }

    const file = document.getElementById("categoryImage");
    const files = file.files;
    const fileBanner = document.getElementById("categoryBanner");
    const filesBanner = fileBanner.files;

    if (id === null && isDuplicateCategoryName(formInsertData.category_name)) {
      setCategoryNameError("This category name already exists");
      return;
    }

    if (formInsertData.image_path === "" && files.length === 0) {
      setImageValidation1(true);
      return;
    }

    if (formInsertData.banner_path === "" && filesBanner.length === 0) {
      setImageValidation2(true);
      return;
    }

    if (files.length > 0) {
      const imagePath = getNormalizedImagePath(files[0], "image-");
      values.image_path = imagePath;
      formInsertData.image_path = imagePath;
    } else {
      values.image_path = formInsertData.image_path;
    }

    if (filesBanner.length > 0) {
      const bannerPath = getNormalizedImagePath(filesBanner[0], "image-");
      values.banner_path = bannerPath;
      formInsertData.banner_path = bannerPath;
    } else {
      values.banner_path = formInsertData.banner_path;
    }

    values.category_id = formInsertData.category_id;
    values.category_name = formInsertData.category_name;
    setLoadInsert(true);
    postMethod("api/masters/product/category/insert", values).then((dataD) => {
      const data = dataD.data[0];
      if (data.valid) {
        if (files.length > 0) {
          uploadImageFunc();
        } else if (filesBanner.length > 0) {
          uploadImageBannerFunc();
        } else {
          setSuccess(true);
          setTimeout(() => {
            props.history.push("/branch/product/category");
          }, 2000);
        }
      }
    });
  };

  const uploadImageFunc = () => {
    const file = document.getElementById("categoryImage");
    const files = file.files;
    const formData = new FormData();

    if (files.length > 0) {
      formData.append("files", files[0], formInsertData.image_path.split(".")[0]);
    }

    const fileBanner = document.getElementById("categoryBanner");
    const filesBanner = fileBanner.files;

    const url = API_BASE_URL + "api/masters/branch/UploadProductCategory";
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        "auth-token": localStorage.getItem("jwl_token"),
      },
    };

    post(url, formData, config).then(
      () => {
        if (filesBanner.length > 0) {
          uploadImageBannerFunc();
        } else {
          setSuccess(true);
          setTimeout(() => {
            props.history.push("/branch/product/category");
          }, 2000);
        }
      },
      () => {
        setSuccess(false);
        setLoadInsert(false);
      }
    );
  };

  const uploadImageBannerFunc = () => {
    const fileBanner = document.getElementById("categoryBanner");
    const filesBanner = fileBanner.files;
    const formDataBanner = new FormData();

    if (filesBanner.length > 0) {
      formDataBanner.append("files", filesBanner[0], formInsertData.banner_path.split(".")[0]);
    }

    const url = API_BASE_URL + "api/masters/branch/UploadProductCategoryBanner";
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        "auth-token": localStorage.getItem("jwl_token"),
      },
    };

    post(url, formDataBanner, config).then(
      () => {
        setSuccess(true);
        setTimeout(() => {
          props.history.push("/branch/product/category");
        }, 2000);
      },
      () => {
        setSuccess(true);
        setLoadInsert(false);
      }
    );
  };

  const handleDelete = () => {
    const proceed = window.confirm("Do you Really Wish to Delete this Entry..?!");

    if (proceed) {
      setLoadDelete(true);
      postMethod("api/masters/product/category/delete", {
        category_id: formInsertData.category_id,
      }).then((data) => {
        if (data.data[0].valid) {
          setSuccessDelete(true);
          setTimeout(() => {
            props.history.push("/branch/product/category");
          }, 2000);
        } else {
          setSuccessDelete(true);
          setTimeout(() => {
            setSuccessDelete(false);
          }, 4000);
          setLoadDeleteMsg(data.error);
          setLoadDelete(false);
        }
      });
    }
  };

  const getCategorySearchList = () => {
    postMethod("api/masters/product/subcategory/search_list_category", {
      search: formInsertData.category_name,
    }).then((data) => setCategoryList(data.data));
  };

  useEffect(() => {
    getCategorySearchList();
  }, [formInsertData.category_name]);

  useEffect(() => {
    if (id !== null) {
      setLoad(true);
      const temp = window.atob(id);
      postMethod("api/masters/product/category/preview", { category_id: temp }).then((dataD) => {
        const data = dataD.data[0];
        setFormInsertData({
          ...formInsertData,
          category_id: data.category_id,
          category_name: data.category_name,
          banner_path: data.banner_path,
          image_path: data.image_path,
        });
        setImageObj({ ...imageObj, image: data.image_path, banner: data.banner_path });
        setLoad(false);
      });
    }
    postMethod("api/masters/product/subcategory/search_list_category", { search: "" }).then(
      (data) => setCategoryList(data.data)
    );
  }, []);

  return (
    <>
      {load ? <Loader /> : null}
      <Form onSubmit={handleSubmit(insertData)} className="product-category-editor-form">
        <input
          type="hidden"
          name="category_id"
          value={id == null ? "0" : formInsertData.category_id}
          ref={register}
        />
        <div className="card shadow product-category-editor-card">
          <div className="product-category-editor-header">
            <div className="product-category-editor-title">
              <span className="product-category-editor-icon">
                <i className="fa fa-cubes"></i>
              </span>
              <div>
                <h3>{id ? "Edit Product Category" : "Add Product Category"}</h3>
                <p>Manage category name, listing image and banner artwork.</p>
              </div>
            </div>
          </div>

          <div className="card-body product-category-editor-body">
            <Row>
              <Col lg={5} md={12}>
                <div className="product-category-editor-section">
                  <FormGroup className="product-category-editor-field mb-0">
                    <Label>
                      Category Name <span>*</span>
                    </Label>
                    <Autocomplete
                      id="CategoryName"
                      freeSolo
                      size="small"
                      value={formInsertData.category_name || ""}
                      options={categoryList.map((option) => option.category_name)}
                     onChange={(event, value) => {
  const nextName = value || "";

  setFormInsertData((prev) => ({
    ...prev,
    category_name: nextName,
  }));

 setCategoryNameError(
  id === null && isDuplicateCategoryName(nextName)
    ? "This category name already exists"
    : ""
);
}}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          className="product-category-editor-autocomplete"
                          placeholder="Enter category name"
                         onChange={(e) => {
  const nextName = e.target.value;

  setFormInsertData((prev) => ({
    ...prev,
    category_name: nextName,
  }));

  setCategoryNameError(
    isDuplicateCategoryName(nextName)
      ? "This category name already exists"
      : ""
  );
}}
                          margin="normal"
                          variant="outlined"
                        />
                      )}
                    />
                    {categoryNameError ? (
                      <span className="form-text text-danger">
                        {categoryNameError}
                      </span>
                    ) : null}
                  </FormGroup>
                </div>
              </Col>

              <Col lg={7} md={12}>
                <div className="product-category-editor-assets">
                  <div className="product-category-editor-upload">
                    <div className="product-category-editor-upload-head">
                      <div>
                        <h5>Category Image</h5>
                        <p>Recommended 350 x 236</p>
                      </div>
                      {imageValidation1 ? <span>Required</span> : null}
                    </div>
                    <div className="product-category-editor-preview product-category-editor-image-preview">
                      {imageObj.image ? (
                        <img
                          src={getImageSrc(imageObj.image, "CustomerUploads/")}
                          alt="Product category"
                        />
                      ) : (
                        <div>
                          <i className="fa fa-image"></i>
                          <p>No image selected</p>
                        </div>
                      )}
                    </div>
                    <label className="product-category-editor-file">
                      <input
                        id="categoryImage"
                        type="file"
                        multiple={false}
                        accept="image/*"
                        name="Choose Image"
                        onChange={(e) => {
                          previewFile(e.target.files[0], "image");
                          setImageValidation1(false);
                        }}
                      />
                      <i className="fa fa-cloud-upload"></i>
                      <span>
                        Choose Image
                        <small>JPG, PNG</small>
                      </span>
                    </label>
                  </div>

                  <div className="product-category-editor-upload">
                    <div className="product-category-editor-upload-head">
                      <div>
                        <h5>Banner</h5>
                        <p>Recommended 1110 x 320</p>
                      </div>
                      {imageValidation2 ? <span>Required</span> : null}
                    </div>
                    <div className="product-category-editor-preview product-category-editor-banner-preview">
                      {imageObj.banner ? (
                        <img
                          src={getImageSrc(imageObj.banner, "BranchBannerCategory/")}
                          alt="Product category banner"
                        />
                      ) : (
                        <div>
                          <i className="fa fa-picture-o"></i>
                          <p>No banner selected</p>
                        </div>
                      )}
                    </div>
                    <label className="product-category-editor-file">
                      <input
                        id="categoryBanner"
                        type="file"
                        multiple={false}
                        accept="image/*"
                        name="Choose Image"
                        onChange={(e) => {
                          previewFile(e.target.files[0], "banner");
                          setImageValidation2(false);
                        }}
                      />
                      <i className="fa fa-cloud-upload"></i>
                      <span>
                        Choose Banner
                        <small>JPG, PNG</small>
                      </span>
                    </label>
                  </div>
                </div>
              </Col>
            </Row>

            {success ? <Alert color="success">Saved Successfully</Alert> : null}
            {successDelete ? <Alert color="danger">{loadDeleteMsg}</Alert> : null}
          </div>

          <div className="product-category-editor-footer">
            <a href="/branch/product/category" className="btn product-category-editor-cancel-btn">
              Cancel
            </a>
            {id &&
              (loadDelete ? (
                <button type="button" className="btn btn-danger product-category-editor-action-btn">
                  Deleting..
                </button>
              ) : (
                <button
                  type="button"
                  onClick={handleDelete}
                  className="btn btn-danger product-category-editor-action-btn"
                >
                  Delete
                </button>
              ))}

            {loadInser ? (
              <button type="button" className="btn btn-primary product-category-editor-action-btn">
                Saving..
              </button>
            ) : (
              <button type="submit" className="btn btn-primary product-category-editor-action-btn">
                Save
              </button>
            )}
          </div>
        </div>
      </Form>
    </>
  );
};

export default AddCategory;
